'use client';
const DEPRECATED_ICON_SIZES = [
    '10p',
    '28p',
    '32p',
    '40p',
    '48p',
    '60p'
];
const DEPRECATED_ICON_SKINS = [
    'white'
];

export { DEPRECATED_ICON_SIZES, DEPRECATED_ICON_SKINS };
